import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _MessageTemplate, _PdfLibraryFactory } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { JsonFormaterInput } from "../../../theme/Component/JsonFormaterInput";
import { PdfLibraryFactoryitems } from "./PdfLibraryFactoryitems";
import { PrintJson } from "../../../theme/Component/PrintJson";




export const PdfLibraryFactory = () => {

    const pdf = useDataBean(_PdfLibraryFactory);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modalitems, setModalitems] = useState<any>({ name: "Items", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const x = {
            // "IDProject": idAdquisitionProject,
            "State": 1
        }
        pdf.instance.getPdfLibraryFactoryCatalogPorPropiedades(x, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }




    const create = () => {
        pdf.setBean({
            State: 1,
            Dictionary: 'libreriaPDF'
        });
        setModal({ ...modal, "view": true });
    }

    const eliminarItem = () => {
        pdf.bean.State = 2;
        //console.log(PaymentMethod.bean);
        editaItem();
        setModalC({ ...modalC, ['view']: false });
    }

    const editaItem = () => {
        //console.log(PaymentMethod.bean);
        pdf.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPdfLibraryFactory', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        // { title: 'Tipo Proceso', property: 'IDProcessType', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Items', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalitems({ ...modalitems, "name": `Editar ${pdf.bean.Name}`, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${pdf.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Plantilla PDF">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={pdf.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={MessageTemplate.bean.IDProcessType} onChange={(e: any) => { MessageTemplate.setBean({ ...MessageTemplate.bean, "IDProcessType": e }) }} />
                            </div> */}
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={pdf.bean.Name} onChange={pdf.handleChange} />

                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={pdf.bean.Description} onChange={pdf.handleChange} />
                            </div>
                            {/* <div className="col-md-12">

                                <JsonFormaterInput rows={20} inputType="string" value={pdf.bean.Name} onChange={() => { }} returnType="object" _label="Respuesta" />

                            </div> */}

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={eliminarItem}>
                        <strong>Eliminar item {pdf.bean.Name}</strong>
                    </ModalConfirm>
                    <Modal modal={modalitems} updateModal={setModalitems} >
                        <div className="row">
                            <PrintJson json={pdf.bean.IDPdfLibraryFactory} />
                            <PdfLibraryFactoryitems IDPdfLibraryFactory={pdf.bean.IDPdfLibraryFactory} />
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}